import store from "../store";
import Constants from "../config/constants";
import {
  serviceCreateReview,
  serviceDeleteReview,
  serviceGetReview,
  serviceUpdateReview,
} from "../services/Review.service";
import { serviceDeleteIndustry } from "../services/Industry.service";

export const FETCH_INIT = "FETCH_INIT_REVIEW";
export const FETCHED = "FETCHED_REVIEW";
export const FETCHED_FAIL = "FETCHED_FAIL_REVIEW";
export const FETCHED_FILTER = "FETCHED_FILTER_REVIEW";
// export const NEXT_PREQUESTS = 'NEXT_PREQUESTS';
// export const PREV_PREQUESTS = 'PREV_PREQUESTS';
export const FETCH_NEXT = "FETCH_NEXT_REVIEW";
export const FILTER = "FILTER_REVIEW";
export const RESET_FILTER = "RESET_FILTER_REVIEW";
export const SET_SORTING = "SET_SORTING_REVIEW";
export const SET_FILTER = "SET_FILTER_REVIEW";
export const SET_PAGE = "SET_PAGE_REVIEW";
export const CHANGE_PAGE = "CHANGE_PAGE_REVIEW";
export const CHANGE_STATUS = "CHANGE_STATE_REVIEW";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_REVIEW";
export const CREATE_DATA = "CREATE_REVIEW";
export const UPDATE_DATA = "UPDATE_REVIEW";
export const DELETE_ITEM = "DELETE_REVIEW";

export function actionFetchReview(
  index = 1,
  sorting = {},
  filter = {},
  shouldReset = false
) {
  const request = serviceGetReview({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  }); // GetReview
  return (dispatch) => {
    if (shouldReset) {
      dispatch({
        type: CHANGE_PAGE,
        payload: 1,
      });
    }
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateReview(data) {
  const request = serviceCreateReview(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionUpdateReview(data) {
  const request = serviceUpdateReview(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: UPDATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionDeleteReview(id) {
  const request = serviceDeleteReview({ id: id });
  return (dispatch) => {
    dispatch({ type: DELETE_ITEM, payload: id });
  };
}

export function actionChangePageReview(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterReview(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusReview(id, status) {
  //const request = serviceUpdateReview({ id: params.id, status: params.type});
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterReview() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageReview(page) {
  const stateData = store.getState().cvReview;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchReview(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
    // this.props.fetchNextUsers(this.props.serverPage + 1, this.props.sorting_data.row, this.props.sorting_data.order, { query: this.props.query, query_data: this.props.query_data });
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
